import axios, { AxiosInstance } from 'axios';
import { accessToken } from '../../../modules/auth';

const addMsalTokenInterceptor = (instance: AxiosInstance) => {
    instance.interceptors.request.use(async (config) => {
        const { getAcquireTokenSilent } = accessToken();
        const accessTokenResponse = await getAcquireTokenSilent();

        return {
            ...config,
            headers: accessTokenResponse.accessToken
                ? {
                      ...config.headers,
                      Authorization: `Bearer ${accessTokenResponse?.accessToken}`,
                  }
                : config.headers,
            cancelToken: new axios.CancelToken((cancel) => {
                if (!accessTokenResponse.accessToken) {
                    cancel('Cancel repeated request');
                }
            }),
        };
    });
};

export default addMsalTokenInterceptor;
